/* eslint-disable react/jsx-filename-extension */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ToastAlertProvider from "./Config/Providers/ToastAlert";
import store from "./Config/Redux/store";
// integrating sentry

const root = ReactDOM.createRoot(document.getElementById("root"));
const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN;
const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV;

if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: SENTRY_DSN_URL, // Project DSN value
    integrations: [new Integrations.BrowserTracing(), new Sentry.Replay()],
    tracesSampleRate: 0.2,
    environment: SENTRY_ENV,
  });
}

root.render(
  <Router>
    <Provider store={store}>
      <ToastAlertProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </ToastAlertProvider>
    </Provider>
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
